<template>
  <v-form>
    <v-container>
      <!-- <v-card>
        <v-container>
          <v-card-title>従業員データアップロード</v-card-title>
          <v-layout row wrap>
            <br />
            <v-flex xs12>
              <v-text-field
                label="従業員データファイル"
                @click="pickFile"
                v-model="fileName"
                prepend-icon="attach_file"
                hint="CSVファイル"
                v-validate="'required'"
                data-vv-name="userId"
                :error-messages="errors.collect('userId')"
              ></v-text-field>
              <input
                type="file"
                ref="file"
                style="display: none"
                accept=".csv, .xls"
                @change="onFileChange($event)"
              />
            </v-flex>
          </v-layout>
          <br />

          <v-radio-group v-model="fileFormat" row :mandatory="false">
            <v-radio label="SHIFT-JIS" value="SHIFT-JIS"></v-radio>
            <v-radio label="UTF-8" value="UTF-8"></v-radio>
          </v-radio-group>

          <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
            <v-icon dark left>cloud_upload</v-icon>アップロード実行
          </v-btn>          
        </v-container>
      </v-card>
      <br /> -->

      <v-card>
        <v-container>
          <v-card-title>従業員データ一覧</v-card-title>            

          <v-container style="padding-bottom: 45px; padding-top: 5px;">
            <v-layout>
              <!-- <v-flex xs12 sm4 md4>
                <v-switch
                  label="有効データのみ"
                  color="info"
                  value="info"
                  hide-details
                  v-model="switch1"
                  @change="changeSwitch($event)"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-switch
                  label="すべて"
                  color="success"
                  value="success"
                  hide-details
                  v-model="switch2"
                  @change="changeSwitch($event)"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-switch
                  label="無効データのみ"
                  color="error"
                  value="error"
                  hide-details
                  v-model="switch3"
                  @change="changeSwitch($event)"
                ></v-switch>
              </v-flex> -->

              <v-flex xs12 sm12>
                <!-- 등록버튼을 오른쪽 끝으로 보내기 위한 더미 -->
              </v-flex>
              <v-flex xs12 sm2 md2 v-if="(user.adminRole === '1')">
                <v-btn block color="primary" dark :to="{name: 'admin/new-user-regist', params: { category: 'dummy' }}">
                  <v-icon dark left>create</v-icon>新規登録
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <!-- <v-data-table
            :headers="headers"
            :items="users"
            hide-actions
            class="elevation-1"
            :custom-sort="customSort"
            :customFilter="customFilter"
            :search="selectSwitch"
          > -->
          <v-data-table
            :headers="headers"
            :items="users"
            hide-actions
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props" v-if="(user.adminRole === '1')">
              <td class="text-xs-left px-3"  @click="forwardUserEdit(props.item)">{{ props.item.userId }}</td>
              <td class="text-xs-left px-3"  @click="forwardUserEdit(props.item)">{{ props.item.userName }}</td>
              <td class="text-xs-left px-3"  @click="forwardUserEdit(props.item)">{{ props.item.userGroup }}</td>
              <td class="text-xs-left px-3"  @click="forwardUserEdit(props.item)">{{ props.item.userGroup2 }}</td>
              <td class="text-xs-left px-3"  @click="forwardUserEdit(props.item)">{{ props.item.userGroup3 }}</td>
              <td class="text-xs-left px-3"  @click="forwardUserEdit(props.item)">{{ props.item.country }}</td>
              <td class="text-xs-left px-3"  @click="forwardUserEdit(props.item)">{{ props.item.staffType }}</td>
              <td class="text-xs-left px-3">
                <a @click="editUser(props.item)" v-if="props.item.adminRole === '0'">一般社員</a>
                <a @click="editUser(props.item)" v-if="props.item.adminRole === '1'">人事管理者</a>
                <a @click="editUser(props.item)" v-if="props.item.adminRole === '2'">本部担当者</a>
                <a @click="editUser(props.item)" v-if="props.item.adminRole === '3'">発注確認者</a>
                <a @click="editUser(props.item)" v-if="props.item.adminRole === '9'">ZUMI</a>
                <a v-else></a>
              </td>
              <td class="text-xs-left px-3">
                <a @click="initPassword(props.item)">初期化</a>
              </td>
            </template>
            <template v-slot:items="props" v-else>
              <td class="text-xs-left px-3" >{{ props.item.userId }}</td>
              <td class="text-xs-left px-3" >{{ props.item.userName }}</td>
              <td class="text-xs-left px-3" >{{ props.item.userGroup }}</td>
              <td class="text-xs-left px-3" >{{ props.item.userGroup2 }}</td>
              <td class="text-xs-left px-3" >{{ props.item.userGroup3 }}</td>
              <td class="text-xs-left px-3" >{{ props.item.country }}</td>
              <td class="text-xs-left px-3" >{{ props.item.staffType }}</td>
              <td class="text-xs-left px-3">
                <a v-if="props.item.adminRole === '0'">一般社員</a>
                <a v-if="props.item.adminRole === '1'">人事管理者</a>
                <a v-if="props.item.adminRole === '2'">本部担当者</a>
                <a v-if="props.item.adminRole === '3'">発注確認者</a>
                <a v-if="props.item.adminRole === '9'">ZUMI</a>
                <a v-else></a>
              </td>
              <td class="text-xs-left px-3">
                <a @click="initPassword(props.item)">初期化</a>
              </td>
            </template>
          </v-data-table>
        </v-container>
      </v-card>

      <br />
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-container>
            <v-card-title>
              <span class="headline">権限設定</span>
            </v-card-title>
            <v-layout row wrap align-center>
              <v-flex>
                <v-select
                  v-model="editingAdminRole"
                  :items="adminRoleItems"
                  item-text="adminRoleName"
                  item-value="adminRoleCode"
                  label="権限"
                  return-object
                ></v-select>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close()">
                <v-icon dark>arrow_back</v-icon>{{ $t('back-btn') }}
              </v-btn>
              <v-btn color="blue darken-1" flat @click="save()">
                <v-icon dark>save</v-icon>変更
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<style></style>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    
    this.loadUsers()
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
  },
  data() {
    return {
      fileFormat: 'SHIFT-JIS',
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,

      // switch1: 'info',
      // switch2: '',
      // switch3: '',
      // selectSwitch: 'info',

      editingUserId: '',
      editingAdminRole: {
        adminRoleName: '',
        adminRoleCode: ''
      },

      fileName: '',
      file: '',
      dialog: false,
      editedIndex: -1,
      users: [],
      adminRoleItems: [
        {
          adminRoleName: '一般社員',
          adminRoleCode: '0'
        },
        {
          adminRoleName: '人事管理者',
          adminRoleCode: '1'
        },
        {
          adminRoleName: '本部担当者',
          adminRoleCode: '2'
        },
        {
          adminRoleName: '発注確認者',
          adminRoleCode: '3'
        }
      ],
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'userId',
          class: 'px-3',
          width: '10%'
        },
        {
          text: '名前',
          align: 'left',
          value: 'userName',
          class: 'px-3',
          width: '20%'
        },
        {
          text: '部署',
          align: 'left',
          value: 'userGroup',
          class: 'px-3',
          width: '10%'
        },
        {
          text: '課',
          align: 'left',
          value: 'userGroup2',
          sortable: false,
          class: 'px-3',
          width: '10%'
        },
        {
          text: 'Group',
          align: 'left',
          value: 'userGroup3',
          sortable: false,
          class: 'px-3',
          width: '10%'
        },
        {
          text: '勤務地（国）',
          align: 'left',
          value: 'country',
          sortable: false,
          class: 'px-3',
          width: '10%'
        },
        {
          text: '契約種類',
          align: 'left',
          value: 'userType',
          sortable: false,
          class: 'px-3',
          width: '10%'
        },
        {
          text: '権限',
          align: 'left',
          value: 'adminRole',
          sortable: false,
          class: 'px-3',
          width: '10%'
        },
        {
          text: 'パスワード初期化',
          align: 'left',
          value: 'passwordInit',
          sortable: false,
          class: 'px-3',
          width: '10%'
        }
      ],
      editedItem: {
        userId: '',
        userName: '',
        userGroup: '',
        userType: '',
        adminRole: ''
      }
    }
  },
  methods: {
    forwardUserEdit(userRow) {
      this.$router.push({
        name: 'admin/new-user-update',
        params: {
          userId: userRow.userId
        }
      })
    },
    customSort(items, index, isDesc) {
      console.log('custom sort. userId ')
      items.sort((a, b) => {
        if (!isDesc) {
          if (a.userId < b.userId) {
            return -1
          } else if (a.userId > b.userId) {
            return 1
          }
        } else {
          if (a.userId < b.userId) {
            return 1
          } else if (a.userId > b.userId) {
            return -1
          }
        }
        return 0
      })
      return items
    },
    loadUsers() {
      let thisObj = this
      // 初期表示時の
      thisObj.loading = true

      ServerApiCallService.users()
        .then(response => {
          thisObj.users = response.data.users
          
          // 初期表示時の
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    fileUpload() {
      console.log('fileUpload')
      let thisObj = this
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading1 = true
      ServerApiCallService.sendUsersFile(formData, sendContext)
        .then(response => {
          this.loadUsers()
          thisObj.loading1 = false
        })
        .catch(error => {
          thisObj.loading1 = false
        })
    },
    editUser(item) {
      let thisObj = this
      console.log('open edit user dialog')
      thisObj.users.forEach(function(row) {
        if (row.userId === item.userId) {
          thisObj.adminRoleItems.forEach(function(authItem) {
            if (authItem.adminRoleCode === item.adminRole) {
              thisObj.editingUserId = item.userId
              thisObj.editingAdminRole = {
                adminRoleName: authItem.adminRoleName,
                adminRoleCode: authItem.adminRoleCode
              }
            }
          })
        }
      })
      this.dialog = true
    },
    initPassword(item) {
      console.log('init password')

      let thisObj = this
      let sendRequest = {
        userId: item.userId
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      ServerApiCallService.usersInitializePassword(
        sendRequest,
        sendContext
      ).catch(error => {
        console.log('There was an error:', error.response)
      })
    },
    save() {
      console.log('save dialog')
      let thisObj = this
      let sendRequest = {
        userId: this.editingUserId,
        adminRole: this.editingAdminRole.adminRoleCode
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      ServerApiCallService.usersAuthPut(sendRequest, sendContext)
        .then(() => {
          thisObj.users.forEach(function(row) {
            if (row.userId === thisObj.editingUserId) {
              row.adminRole = thisObj.editingAdminRole.adminRoleCode
            }
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      // Object.assign(this.tableDatas[this.editedIndex], this.editedItem)
      this.close()
    },
    close() {
      console.log('close dialog')
      this.dialog = false
    },
    // changeSwitch(e) {
    //   console.log('change switch')
    //   if (e === 'info') {
    //     this.selectSwitch = 'info'
    //     this.switch2 = null
    //     this.switch3 = null
    //   } else if (e === 'success') {
    //     this.selectSwitch = 'success'
    //     this.switch1 = null
    //     this.switch3 = null
    //   } else if (e === 'error') {
    //     this.selectSwitch = 'error'
    //     this.switch1 = null
    //     this.switch2 = null
    //   } else {
    //     this.selectSwitch = 'info'
    //     this.switch1 = 'info'
    //     this.switch2 = null
    //     this.switch3 = null
    //   }
    // },
    customFilter(items, search) {
      let filterlingItems = items.filter(
        item =>
          (search === 'info' && item.isDeleted === '0') ||
          search === 'success' ||
          (search === 'error' && item.isDeleted === '1')
      )

      return items
      // return filterlingItems
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  }
}
</script>
